// import styles from "./VenuePageSecondNav.module.css";

// export default function VenuePageSecondNav({
//   activeSection,
//   onSectionChange,
//   comparisonCount = 0,
// }) {
//   const navItems = [

//     {
//       id: "featured",
//       label: "Featured Venues",
//     },
//     {
//       id: "compare",
//       label: "Compare Hotels",
//       count: comparisonCount,
//     },
//      {
//       id: "hotels",
//       label: "Select Hotels",
//     },
//     // {
//     //   id: "search",
//     //   label: "Search Hotels",
//     // },
//   ];

//   const handleNavigation = (sectionId) => {
//     onSectionChange(sectionId);

//     const target = document.getElementById(sectionId);

//     if (target) {
//       const navOffset = 90;

//       const targetPosition =
//         target.getBoundingClientRect().top +
//         window.scrollY -
//         navOffset;

//       window.scrollTo({
//         top: targetPosition,
//         behavior: "smooth",
//       });
//     }
//   };

//   return (
//     <nav
//       className={styles.nav}
//       aria-label="Venue Planner Navigation"
//     >
//       <div className={styles.container}>
//         <div className={styles.navItems}>
//           {navItems.map((item) => (
//             <button
//               key={item.id}
//               type="button"
//               className={`${styles.navItem} ${
//                 activeSection === item.id ? styles.active : ""
//               }`}
//               onClick={() => handleNavigation(item.id)}
//             >
//               <span>{item.label}</span>

//               {item.count > 0 && (
//                 <span className={styles.count}>
//                   {item.count}
//                 </span>
//               )}
//             </button>
//           ))}
//         </div>
//       </div>
//     </nav>
//   );
// }

import styles from "./VenuePageSecondNav.module.css";

export default function VenuePageSecondNav({
  activeSection,
  onSectionChange,
  comparisonCount = 0,
}) {
  const navItems = [

    {
      id: "featured",
      label: "Featured Venues",
    },
    {
      id: "hotels",
      label: "Search/Select Hotels",
    },
    
    {
      id: "compare",
      label: "Compare Hotels",
      count: comparisonCount,
    },
     
  ];

  const handleNavigation = (sectionId) => {
    onSectionChange(sectionId);

    const target = document.getElementById(sectionId);

    if (target) {
      const navOffset = 90;

      const targetPosition =
        target.getBoundingClientRect().top +
        window.scrollY -
        navOffset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <nav
      className={styles.nav}
      aria-label="Venue Planner Navigation"
    >
      <div className={styles.container}>
        <div className={styles.navItems}>
          {navItems.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`${styles.navItem} ${
                activeSection === item.id ? styles.active : ""
              }`}
              onClick={() => handleNavigation(item.id)}
            >
              <span>{item.label}</span>

              {item.count > 0 && (
                <span className={styles.count}>
                  {item.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}